module.exports = __webpack_public_path__ + "static/fetureMain1-6b56276ee3bbe51c28fe054dc5aca4e6.png";